import React from "react";
import NavUp from "../commons/NavUp";
import Title from "../pages/Login/Components/title/title";
import LoginWithEmail from "./Component/LoginWithEmail";

class Admin extends React.Component {
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        ele.classList.add("available");
        setTimeout(() => {
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  render() {
    return (
      <React.Fragment>
        <NavUp />
        <div
          id="loginAdmin"
          className="text-center alert alert-danger d-none"
          role="alert"
        ></div>
        <Title text1="Welcome!" />
        <br />
        <br />
        <br />
        <LoginWithEmail />
      </React.Fragment>
    );
  }
}

export default Admin;
